import { useSuspenseQuery } from '@tanstack/react-query'
import { data as routerData, type LoaderFunctionArgs, type RouterContextProvider, useLoaderData } from 'react-router'

import { clientContext } from 'apps/employer_dashboard/router_contexts'
import EmployersResourcesPage from 'components/employers/EmployersResourcesPage'
import { getRequestIdFromError } from 'utils/errors'
import { getDashboardEmployersResources, getGetDashboardEmployersResourcesQueryKey } from 'utils/web_api'

const query = {
  queryKey: getGetDashboardEmployersResourcesQueryKey(),
  queryFn: getDashboardEmployersResources,
}

export async function loader ({ context }: LoaderFunctionArgs<RouterContextProvider>) {
  const queryClient = context.get(clientContext)

  try {
    const data = await queryClient?.ensureQueryData(query)

    return { data }
  } catch (error) {
    throw routerData({
      heading: 'We could not load the resources page',
      message: 'Something unexpected happened. We have been notified and are looking into it.',
      requestId: getRequestIdFromError(error)
    })
  }
}

export function ResourcesPage () {
  const { data: initialData } = useLoaderData<typeof loader>()
  const { data } = useSuspenseQuery({
    ...query,
    initialData
  })

  // TODO: Move the `<EmployersResourcesPage />` component into this page
  // component after the ER dashboard migration is complete.

  return (
    <div>
      <EmployersResourcesPage resources={data.resources} />
    </div>
  )
}
